import React from 'react';
import { Navigate } from 'react-router-dom';
import MarketingLayout from '../components/Layout/MarketingLayout';
import PricingPlansContent from '../components/billing/PricingPlansContent';
import { useAuth } from '../context/AuthContext';
import { RouteAuthSpinner } from '../components/auth/RouteAuthSpinner';

export default function PricingPage() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <MarketingLayout>
        <div className="min-h-[50vh] flex items-center justify-center pt-24">
          <RouteAuthSpinner />
        </div>
      </MarketingLayout>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/app/pricing" replace />;
  }

  return (
    <MarketingLayout>
      <PricingPlansContent variant="marketing" />
    </MarketingLayout>
  );
}
